/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Styles from './index.module.css';

export default function TextField({
  value,
  onChange,
  className,
  ...props
}) {
  return (
    <input
      spellCheck={false}
      className={Styles.textField}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
}

TextField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

TextField.defaultProps = {
  value: '',
  onChange: PropTypes.func,
  className: '',
};
